import { render, staticRenderFns } from "./serviceFeelingsList.vue?vue&type=template&id=34bde890&scoped=true&"
import script from "./serviceFeelingsList.vue?vue&type=script&lang=ts&"
export * from "./serviceFeelingsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bde890",
  null
  
)

export default component.exports